/**
 * Ludimila Rosa Semijoias — Storefront Interactive Behaviors
 */
document.addEventListener('DOMContentLoaded', () => {
  // 1. Editorial Video Cards Controller
  const playButtons = document.querySelectorAll('.lr-play-btn');
  playButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const poster = btn.closest('.lr-video-poster');
      if (!poster) return;
      const video = poster.querySelector('video');
      if (!video) return;

      // Pause all other videos
      document.querySelectorAll('.lr-video-poster video').forEach(otherVid => {
        if (otherVid !== video) {
          otherVid.pause();
          const otherBtn = otherVid.closest('.lr-video-poster')?.querySelector('.lr-play-btn');
          if (otherBtn) otherBtn.style.display = 'grid';
          otherVid.controls = false;
        }
      });

      if (video.paused) {
        video.controls = true;
        video.play().then(() => {
          btn.style.display = 'none';
        }).catch(err => {
          console.warn('Autoplay prevented or error:', err);
        });

        video.addEventListener('ended', () => {
          btn.style.display = 'grid';
          video.controls = false;
        }, { once: true });

        video.addEventListener('pause', () => {
          if (!video.seeking) {
            btn.style.display = 'grid';
          }
        });

        video.addEventListener('play', () => {
          btn.style.display = 'none';
        });
      } else {
        video.pause();
        btn.style.display = 'grid';
      }
    });
  });

  // 2. Lookbook Hotspot Interactivity
  const hotspots = document.querySelectorAll('.lr-hotspot');
  const lookProducts = document.querySelectorAll('.lr-look-product');

  hotspots.forEach((spot) => {
    spot.addEventListener('click', (e) => {
      e.preventDefault();
      const targetIndex = spot.getAttribute('data-target-index');
      
      hotspots.forEach(s => s.classList.remove('active'));
      spot.classList.add('active');

      lookProducts.forEach((prod) => {
        if (prod.getAttribute('data-index') === targetIndex) {
          prod.classList.add('active');
          prod.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } else {
          prod.classList.remove('active');
        }
      });
    });
  });

  lookProducts.forEach((prod) => {
    prod.addEventListener('mouseenter', () => {
      const idx = prod.getAttribute('data-index');
      hotspots.forEach(s => {
        if (s.getAttribute('data-target-index') === idx) {
          s.classList.add('active');
        } else {
          s.classList.remove('active');
        }
      });
    });
  });

  // 3. Mobile Navigation Drawer Toggle
  const mobileMenuBtn = document.querySelector('.lr-mobile-menu-btn');
  const mobileDrawer = document.querySelector('.lr-mobile-drawer');
  const mobileDrawerClose = document.querySelector('.lr-mobile-drawer-close');
  const mobileDrawerOverlay = document.querySelector('.lr-mobile-drawer-overlay');

  function openMobileMenu() {
    if (mobileDrawer) mobileDrawer.classList.add('is-open');
    if (mobileDrawerOverlay) mobileDrawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (mobileDrawer) mobileDrawer.classList.remove('is-open');
    if (mobileDrawerOverlay) mobileDrawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openMobileMenu();
    });
  }

  if (mobileDrawerClose) {
    mobileDrawerClose.addEventListener('click', (e) => {
      e.preventDefault();
      closeMobileMenu();
    });
  }

  if (mobileDrawerOverlay) {
    mobileDrawerOverlay.addEventListener('click', closeMobileMenu);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileDrawer && mobileDrawer.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  // 4. Cart Drawer trigger (opens native Horizon/Dawn theme-drawer)
  const cartButtons = document.querySelectorAll('.lr-cart-trigger');
  cartButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      const cartDrawer = document.querySelector('#cart-drawer') || document.querySelector('theme-drawer#cart-drawer') || document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        e.preventDefault();
        cartDrawer.open();
      }
    });
  });

  // 5. Search Modal trigger (opens native dialog-component)
  const searchTriggers = document.querySelectorAll('.lr-search-trigger');
  searchTriggers.forEach(btn => {
    btn.addEventListener('click', (e) => {
      const searchModal = document.querySelector('dialog-component#search-modal') || document.querySelector('search-modal') || document.querySelector('#search-modal');
      if (searchModal) {
        if (typeof searchModal.showDialog === 'function') {
          e.preventDefault();
          searchModal.showDialog();
        } else if (typeof searchModal.open === 'function') {
          e.preventDefault();
          searchModal.open();
        }
      }
    });
  });

  // 6. PDP Gallery Controller & Touch Swipe
  const galleryThumbs = document.querySelectorAll('.lr-pdp-thumb-btn');
  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const targetId = thumb.getAttribute('data-target-media-id');
      const container = thumb.closest('.lr-pdp-gallery');
      if (!container) return;

      container.querySelectorAll('.lr-pdp-thumb-btn').forEach(b => {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-selected', 'true');

      container.querySelectorAll('.lr-pdp-media-item').forEach(item => {
        if (item.getAttribute('data-media-id') === targetId) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
          const vid = item.querySelector('video');
          if (vid) vid.pause();
        }
      });

      // Update mobile counter pill
      const allThumbs = Array.from(container.querySelectorAll('.lr-pdp-thumb-btn'));
      const activeIdx = allThumbs.indexOf(thumb) + 1;
      const counterEl = container.querySelector('#lr-pdp-active-num');
      if (counterEl && activeIdx > 0) counterEl.textContent = activeIdx;
    });
  });

  // Mobile Touch Swipe Gesture on PDP Media
  const pdpMediaWrap = document.querySelector('.lr-pdp-main-media-wrap');
  if (pdpMediaWrap) {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;

    pdpMediaWrap.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    pdpMediaWrap.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      handlePdpSwipe();
    }, { passive: true });

    function handlePdpSwipe() {
      const diffX = touchEndX - touchStartX;
      const diffY = touchEndY - touchStartY;
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
        const thumbs = Array.from(document.querySelectorAll('.lr-pdp-thumb-btn'));
        if (thumbs.length <= 1) return;
        const currentActiveIdx = thumbs.findIndex(t => t.classList.contains('is-active'));
        if (diffX < 0) {
          // Swipe Left -> Next Image
          const nextIdx = (currentActiveIdx + 1) % thumbs.length;
          thumbs[nextIdx].click();
          thumbs[nextIdx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } else {
          // Swipe Right -> Previous Image
          const prevIdx = (currentActiveIdx - 1 + thumbs.length) % thumbs.length;
          thumbs[prevIdx].click();
          thumbs[prevIdx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }
  }

  // 7. PDP Variant Selector & Dynamic Price / Availability Switcher
  const pdpSection = document.querySelector('.lr-pdp-section');
  if (pdpSection) {
    const sectionId = pdpSection.getAttribute('data-section-id');
    const jsonEl = document.getElementById(`LRProductJSON-${sectionId}`);
    let productData = null;
    if (jsonEl) {
      try {
        productData = JSON.parse(jsonEl.textContent);
      } catch (err) {
        console.warn('Failed to parse product JSON:', err);
      }
    }

    const formatBRL = (cents) => {
      const num = typeof cents === 'number' ? cents / 100 : (parseInt(cents, 10) || 0) / 100;
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(num);
    };

    const optionPills = pdpSection.querySelectorAll('.lr-option-pill');
    optionPills.forEach(pill => {
      pill.addEventListener('click', () => {
        const group = pill.closest('.lr-pdp-option-group');
        if (!group) return;

        group.querySelectorAll('.lr-option-pill').forEach(p => {
          p.classList.remove('is-active');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-checked', 'true');

        const optIndex = pill.getAttribute('data-option-index');
        const selectedText = group.querySelector('.lr-option-selected-text');
        if (selectedText) {
          selectedText.textContent = pill.getAttribute('data-value');
        }

        if (!productData || !productData.variants) return;

        // Gather currently active options
        const activeGroups = Array.from(pdpSection.querySelectorAll('.lr-pdp-option-group'));
        const currentSelectedValues = activeGroups.map(g => {
          const activePill = g.querySelector('.lr-option-pill.is-active');
          return activePill ? activePill.getAttribute('data-value') : null;
        });

        // Find matching variant
        const matchedVariant = productData.variants.find(v => {
          return currentSelectedValues.every((val, idx) => v.options[idx] === val);
        });

        if (matchedVariant) {
          // Update hidden input
          const variantInput = pdpSection.querySelector('#lr-variant-id-input');
          if (variantInput) variantInput.value = matchedVariant.id;

          // Update price
          const priceDisplay = pdpSection.querySelector('#lr-price-display');
          if (priceDisplay) priceDisplay.textContent = formatBRL(matchedVariant.price);

          // Update compare price
          const compareDisplay = pdpSection.querySelector('#lr-compare-price-display');
          const saleBadge = pdpSection.querySelector('#lr-pdp-badge-sale');
          if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            if (compareDisplay) {
              compareDisplay.textContent = formatBRL(matchedVariant.compare_at_price);
              compareDisplay.classList.remove('is-hidden');
            }
            if (saleBadge) {
              const pct = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) / matchedVariant.compare_at_price) * 100);
              saleBadge.textContent = `${pct}% OFF`;
              saleBadge.style.display = 'block';
            }
          } else {
            if (compareDisplay) compareDisplay.classList.add('is-hidden');
            if (saleBadge) saleBadge.style.display = 'none';
          }

          // Update installments
          const instVal = pdpSection.querySelector('#lr-installment-val');
          if (instVal) {
            instVal.textContent = formatBRL(Math.round(matchedVariant.price / 6));
          }

          // Update availability & CTA button
          const availDisplay = pdpSection.querySelector('#lr-availability-display');
          const atcBtn = pdpSection.querySelector('#lr-add-to-cart-btn');
          const atcBtnText = pdpSection.querySelector('#lr-atc-btn-text');
          const stickyPrice = document.querySelector('#lr-sticky-bar-price');
          const stickyBtn = document.querySelector('#lr-sticky-bar-atc-btn');
          const stickyBtnText = document.querySelector('#lr-sticky-bar-btn-text');

          if (stickyPrice) {
            stickyPrice.textContent = formatBRL(matchedVariant.price);
          }

          if (matchedVariant.available) {
            if (availDisplay) {
              availDisplay.innerHTML = '<span class="lr-avail-badge in-stock"><span class="lr-avail-pulse"></span> Disponível em estoque (Pronta entrega)</span>';
            }
            if (atcBtn) atcBtn.removeAttribute('disabled');
            if (atcBtnText) atcBtnText.textContent = 'Adicionar ao carrinho';
            if (stickyBtn) stickyBtn.removeAttribute('disabled');
            if (stickyBtnText) stickyBtnText.textContent = 'Comprar';
          } else {
            if (availDisplay) {
              availDisplay.innerHTML = '<span class="lr-avail-badge out-of-stock">Esgotado no momento</span>';
            }
            if (atcBtn) atcBtn.setAttribute('disabled', 'disabled');
            if (atcBtnText) atcBtnText.textContent = 'Indisponível';
            if (stickyBtn) stickyBtn.setAttribute('disabled', 'disabled');
            if (stickyBtnText) stickyBtnText.textContent = 'Esgotado';
          }

          // Switch media if variant has featured image
          if (matchedVariant.featured_media && matchedVariant.featured_media.id) {
            const targetThumb = pdpSection.querySelector(`.lr-pdp-thumb-btn[data-target-media-id="${matchedVariant.featured_media.id}"]`);
            if (targetThumb) targetThumb.click();
          }

          // Update URL without page reload
          if (window.history && window.history.replaceState) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set('variant', matchedVariant.id);
            window.history.replaceState({ path: newUrl.href }, '', newUrl.href);
          }
        }
      });
    });
  }

  // 8. PDP Quantity Stepper
  const qtyDecrease = document.querySelectorAll('.lr-qty-decrease');
  const qtyIncrease = document.querySelectorAll('.lr-qty-increase');

  qtyDecrease.forEach(btn => {
    btn.addEventListener('click', () => {
      const stepper = btn.closest('.lr-qty-stepper');
      if (!stepper) return;
      const input = stepper.querySelector('.lr-qty-field');
      if (!input) return;
      const currentVal = parseInt(input.value, 10) || 1;
      if (currentVal > 1) {
        input.value = currentVal - 1;
      }
    });
  });

  qtyIncrease.forEach(btn => {
    btn.addEventListener('click', () => {
      const stepper = btn.closest('.lr-qty-stepper');
      if (!stepper) return;
      const input = stepper.querySelector('.lr-qty-field');
      if (!input) return;
      const currentVal = parseInt(input.value, 10) || 1;
      const maxVal = parseInt(input.getAttribute('max'), 10) || 99;
      if (currentVal < maxVal) {
        input.value = currentVal + 1;
      }
    });
  });

  // 9. PDP Product Recommendations Fetcher
  const recSection = document.querySelector('.lr-pdp-recommendations-section[data-url]');
  if (recSection) {
    const url = recSection.getAttribute('data-url');
    if (url) {
      fetch(url)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newGrid = doc.querySelector('.lr-pdp-rec-grid');
          const currentGrid = recSection.querySelector('.lr-pdp-rec-grid');
          if (newGrid && currentGrid && newGrid.children.length > 0) {
            currentGrid.innerHTML = newGrid.innerHTML;
          }
        })
        .catch(err => {
          // Graceful fallback to static collection items already rendered
          console.debug('Product recommendations fetched with fallback active.');
        });
    }
  }

  // 10. PLP Filter Drawer & Sorting Controller
  const openFilterBtn = document.getElementById('lr-open-filters-btn');
  const closeFilterBtn = document.getElementById('lr-close-filters-btn');
  const filterDrawer = document.getElementById('lr-filter-drawer');
  const filterBackdrop = document.getElementById('lr-filter-backdrop');

  function openFilters() {
    if (filterDrawer) filterDrawer.classList.add('is-open');
    if (filterBackdrop) filterBackdrop.classList.add('is-open');
    if (openFilterBtn) openFilterBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    if (filterDrawer) filterDrawer.classList.remove('is-open');
    if (filterBackdrop) filterBackdrop.classList.remove('is-open');
    if (openFilterBtn) openFilterBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (openFilterBtn) openFilterBtn.addEventListener('click', openFilters);
  if (closeFilterBtn) closeFilterBtn.addEventListener('click', closeFilters);
  if (filterBackdrop) filterBackdrop.addEventListener('click', closeFilters);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && filterDrawer && filterDrawer.classList.contains('is-open')) {
      closeFilters();
    }
  });

  const sortSelect = document.getElementById('LRSortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const form = document.getElementById('LRCollectionFilterForm');
      if (form) {
        form.submit();
      } else {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.href;
      }
    });
  }

  // 11. PDP Mobile Sticky Add to Cart Bar Controller
  const stickyBar = document.getElementById('lr-pdp-sticky-bar');
  const mainAtcBtn = document.getElementById('lr-add-to-cart-btn');
  const stickyAtcBtn = document.getElementById('lr-sticky-bar-atc-btn');
  const floatingWa = document.getElementById('lr-floating-wa');

  if (stickyBar && mainAtcBtn) {
    const handleScroll = () => {
      const rect = mainAtcBtn.getBoundingClientRect();
      // Show sticky bar when the primary button scrolls out above the screen
      if (rect.bottom < 0) {
        stickyBar.classList.add('is-visible');
        if (floatingWa) floatingWa.classList.add('has-sticky-bar');
      } else {
        stickyBar.classList.remove('is-visible');
        if (floatingWa) floatingWa.classList.remove('has-sticky-bar');
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
    handleScroll();

    if (stickyAtcBtn) {
      stickyAtcBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (mainAtcBtn && !mainAtcBtn.disabled) {
          mainAtcBtn.click();
        }
      });
    }
  }
});

